module.exports = __webpack_public_path__ + "img/6e7350cd7160686b8390cf5ca63c533f.svg";